<template>
  <div>
    <v-dialog v-model="dialog" max-width="1200px" persistent scrollable>
      <v-card>
        <v-card-title class="blue darken-4 white--text text-uppercase">
          Xác nhận thông tin khách hàng
          <v-spacer />
          <v-btn dark icon>
            <v-icon @click="cancel" class="mr-n1" :disabled="loading">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider />
        <v-card-text class="py-0">
          <ConfirmLeadTable :documents="importedDocuments" :isImportPreview="true" />
        </v-card-text>
        <v-card-actions class="pa-6">
          <v-btn color="primary" @click="cancel" width="118" :loading="loading" large outlined>Hủy</v-btn>
          <v-spacer />
          <v-btn
            color="primary"
            @click="confirmDialog = true"
            :loading="loading"
            width="118"
            class="white--text elevation-0"
            large
          >
            Xác nhận
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="confirmDialog" persistent max-width="420px">
      <v-card>
        <v-card-title class="headline">Xác nhận thông tin khách hàng</v-card-title>
        <v-card-text>
          <div class="mb-2">Hãy kiểm tra thật kỹ thông tin của khách hàng.</div>
          <v-select v-model="importOrigin" label="Nguồn marketing" :items="LEAD_IMPORT_ORIGIN_OPTIONS" outlined dense />
        </v-card-text>
        <v-card-actions>
          <v-btn color="blue darken-4" text @click="confirmDialog = false" outlined>Hủy</v-btn>
          <v-spacer />
          <v-btn color="blue darken-4" dark class="white--text elevation-0" @click="confirm">Xác nhận</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ConfirmLeadTable from './ConfirmLeadTable'
import { LEAD_IMPORT_ORIGIN_OPTIONS } from './helpers'

export default {
  props: { state: Boolean },
  components: { ConfirmLeadTable },
  computed: { ...mapGetters({ importedDocuments: 'lead/importedItems' }) },
  watch: {
    state(state) {
      this.dialog = state
      if (!state) {
        this.loading = false
      }
    },
  },
  data() {
    return {
      LEAD_IMPORT_ORIGIN_OPTIONS,
      //
      dialog: false,
      loading: false,
      confirmDialog: false,
      importOrigin: '',
    }
  },
  methods: {
    cancel() {
      this.dialog = false
    },
    open() {
      this.dialog = true
    },
    async confirm() {
      this.loading = true
      this.confirmDialog = false
      if (this.importOrigin && this.importOrigin.trim() !== '') {
        const updatedDocuments = this.importedDocuments.map(document => {
          return { ...document, importOrigin: this.importOrigin }
        })
        this.$emit('updateResult', updatedDocuments)
      } else {
        this.$emit('updateResult', this.importedDocuments)
      }
    },
  },
}
</script>

<style scoped>
.card-title {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 24px;
}
.card-content {
  text-align: justify !important;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: normal;
  font-size: 14px !important;
  line-height: 20px;
  color: #3e3e3c !important;
}
.btn {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 14px !important;
  line-height: 20px;
}
</style>
